import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Product Management Software and Tools | Canny';
const Description =
  "Canny is built for product managers. Get all the tools you need in one place — feedback management, roadmaps, changelogs — it's all here!";
const Image = 'https://canny.io/images/canny-social.png';

export default class LandingProductManagementHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/use-cases/product-management' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
